/**
 * Visually groups cart line items that share a `_bundle_id` line item property
 * (e.g. a "Build Your Own Ring" setting added together with a diamond) by
 * tinting their rows and inserting a small label row above the group.
 * Re-runs automatically whenever the cart table's contents change, since the
 * cart drawer/page re-renders its rows via DOM morphing rather than full reloads.
 */
const LABEL_TEXT = 'Bundled item';

function applyBundleGrouping() {
  document.querySelectorAll('.cart-items__table tbody').forEach((tbody) => {
    tbody.querySelectorAll('[data-bundle-label-row]').forEach((el) => el.remove());
    tbody.querySelectorAll('.cart-items__table-row--bundled').forEach((row) => {
      row.classList.remove(
        'cart-items__table-row--bundled',
        'cart-items__table-row--bundled-first',
        'cart-items__table-row--bundled-last'
      );
    });

    /** @type {Map<string, HTMLElement[]>} */
    const groups = new Map();
    tbody.querySelectorAll('tr[data-bundle-id]').forEach((row) => {
      const id = row.getAttribute('data-bundle-id');
      if (!id) return;
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id)?.push(row);
    });

    groups.forEach((rows) => {
      if (rows.length < 2) return;

      rows.forEach((row, index) => {
        row.classList.add('cart-items__table-row--bundled');
        if (index === 0) row.classList.add('cart-items__table-row--bundled-first');
        if (index === rows.length - 1) row.classList.add('cart-items__table-row--bundled-last');
      });

      const columnCount = rows[0].children.length || 4;
      const labelRow = document.createElement('tr');
      labelRow.setAttribute('data-bundle-label-row', '');
      labelRow.className = 'cart-items__bundle-label-row cart-items__table-row--bundled cart-items__table-row--bundled-first';
      const cell = document.createElement('td');
      cell.colSpan = columnCount;
      cell.innerHTML = `<span class="cart-items__bundle-label">${LABEL_TEXT}</span>`;
      labelRow.appendChild(cell);

      rows[0].before(labelRow);
      rows[0].classList.remove('cart-items__table-row--bundled-first');
    });
  });
}

let scheduled = false;
function scheduleApply() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    applyBundleGrouping();
  });
}

const observer = new MutationObserver((mutations) => {
  const relevant = mutations.some(
    (mutation) => mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)
  );
  if (relevant) scheduleApply();
});

observer.observe(document.body, { childList: true, subtree: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleApply);
} else {
  scheduleApply();
}
